module.exports = __webpack_public_path__ + "media/bootstrap-icons/chat-text-ea9063fb.svg";